import { min } from 'date-fns';
import { parseActorDate } from '../../../../../../shared/utils/parseDates';
import { AccountTwrrs } from '../../../type';

export const getTAccTwrrPDate = (el: AccountTwrrs) => min([
  parseActorDate(el['TWRR_PER.DATE_FIN']),
  parseActorDate(el['T_ACC_TWRR_P.CREATE_AT']),
]);
